import { EntityApiService } from '@dfl/react-security';
import { IAddressBook } from 'modules/crm/address-book/interfaces';

class AddressBookService extends EntityApiService<IAddressBook> {}

export default new AddressBookService('/ms-sales/api/admin/address-book');
